// src/api.js — All backend API calls

const BASE = "https://govai-1.onrender.com"; // Localhost for dev

function headers() {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    ...(token ? { "Authorization": `Bearer ${token}` } : {}),
  };
}


async function request(method, url, body) {
  const res = await fetch(`${BASE}${url}`, {
    method,
    headers: headers(),
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
if (res.status === 401 && !url.includes("/api/auth/")) {
    // Session expired or invalid token
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
    return;
  }
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Request failed");
  return data;
}

// ── Auth ────────────────────────────────────────────────────
export const loginUser = (email, password) => request("POST", "/api/auth/login", { email, password });
export const registerUser = (name, email, password, targetExam) => request("POST", "/api/auth/register", { name, email, password, targetExam });

// ── Dashboard ───────────────────────────────────────────────
export const fetchDashboard = () => request("GET", "/api/dashboard");

// ── Questions ───────────────────────────────────────────────
export const fetchQuestions = (subject = "", topic = "", difficulty = "", limit = 10, tag = "") => {
  const p = new URLSearchParams();
  if (subject) p.append("subject", subject);
  if (topic) p.append("topic", topic);
  if (difficulty) p.append("difficulty", difficulty);
  if (tag) p.append("tag", tag);
  p.append("limit", limit);
  return request("GET", `/api/questions?${p}`);
};

export const fetchTopics = () => request("GET", "/api/questions/topics");

// ── Tests ───────────────────────────────────────────────────
export const submitTest = (testType, subject, responses, startedAt) =>
  request("POST", "/api/tests/submit", { testType, subject, responses, startedAt });
export const fetchRecentTests = () => request("GET", "/api/tests/recent");
export const fetchTestResult = (id) => request("GET", `/api/tests/${id}`);

// ── Practice ────────────────────────────────────────────────
export const fetchNextQuestion = (topic = "", excludeIds = []) => {
  const p = new URLSearchParams();
  if (topic) p.append("topic", topic);
  if (excludeIds.length > 0) p.append("excludeIds", excludeIds.join(","));
  return request("GET", `/api/practice/next?${p}`);
};
export const submitAnswer = (questionId, selectedOptionIndex, timeTakenSeconds) =>
  request("POST", "/api/practice/answer", { questionId, selectedOptionIndex, timeTakenSeconds });
export const fetchWeakTopics = () => request("GET", "/api/practice/weak-topics");

// ── Performance ─────────────────────────────────────────────
export const fetchPerformance = (subject = "") =>
  request("GET", `/api/performance${subject ? `?subject=${encodeURIComponent(subject)}` : ""}`);

// ── Previous Papers ─────────────────────────────────────────
export const fetchPapers = () => request("GET", "/api/papers");
export const downloadPaper = (id) => request("GET", `/api/papers/${id}/download`);
export const fetchFormulas = () => request("GET", "/api/formulas");
export const submitChatPrompt = (message, history = []) => request("POST", "/api/ai/chat", { message, history });
export const generateAIQuestions = (topic, difficulty) => request("POST", "/api/ai/generate", { topic, difficulty });
export const generateSyllabus = (examName, timeframe) => request("POST", "/api/ai/syllabus", { examName, timeframe });
export const saveStudyPlan = (syllabus) => request("POST", "/api/ai/save-plan", { syllabus });
export const clearStudyPlan = () => request("POST", "/api/ai/clear-plan");
